import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { ProgressStatus } from "./types";

type Response = {
  data?: unknown;
  error?: ApiError;
};

export const UpdateCredentialProgress = async (
  credentialId: string,
  status: ProgressStatus
): Promise<Response> => {
  try {
    const response = await axios.patch(
      `/cert-roadmap/progress/${credentialId}`,
      { status }
    );
    return { data: response.data.data ?? response.data };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      throw apiError;
    }
    throw {
      statusCode: 500,
      message: "An unexpected error occurred",
    } as ApiError;
  }
};
